import { reactive } from 'vue';
import { UniqueIdentity } from '@/services/balancer/contracts/contracts/unique-identity';

export const uidStore = reactive({
  balance: '-1',
  information: '-',
  setBalance(v: string) {
    this.balance = v;
  },
  async checkIsVerified(uniqueIdentity: UniqueIdentity, userAddress: string) {
    const balances = await uniqueIdentity.balanceOfBatch(
      [userAddress, userAddress],
      [0, 3]
    );
    const balanceNonUS = balances[0].toString();
    const balanceUS = balances[1].toString();
    const isUsIndividual = balanceUS !== '0';
    const balance = isUsIndividual ? balanceUS : balanceNonUS;

    if (balance !== '0') {
      this.information = isUsIndividual
        ? 'U.S. Individual'
        : 'Non-U.S Individual';
    }

    this.setBalance(balance);

    return balance !== '0';
  },
  isLoading() {
    return this.balance === '-1';
  },
  isNotVerify() {
    return this.balance === '0';
  },
  isVerified() {
    return this.balance !== '-1' && this.balance !== '0';
  },
});
